import * as ActionTypes from '../actions'



const patient = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.OPEN_PATIENT_RECORD:
			return action.patient
		case ActionTypes.CLOSE_PATIENT_RECORD:
			return null
		default:
			return state
	}
}

export default patient


// WEBPACK FOOTER //
// ./src/reducers/patient.js